<template>
    <div class="px-3 py-2">
        <v-form
            ref="form"
            lazy-validation
        >
        <b-sidebar id="update_cardInfo" aria-labelledby="sidebar-no-header-title" width="900px" no-header backdrop style="direction:ltr" right :title="lang.add_customer" shadow >
        <template #default="{ hide }">
            <div class="m-1 text-start" style="direction:rtl">
                <div v-if="$store.state.group_id != 9" style="width:120px;margin-right:10px;background:#000;color:#FFF;border-radius:5px" class="btn-primary btn-sm text-center">
                <span>{{lang.update_cardInfo}}</span>
                </div>
                <div v-else>
                    &nbsp;
                </div>
                <div @click="hide" id="hideUpdateCard" style="width:100px;text-align:center;float:left;margin-left:5px;margin-top:-25px;cursor:pointer" class="btn-danger btn-sm">
                <span>{{lang.close}}</span>
            </div>
        </div>
            <v-divider></v-divider>
        <div class="px-3 py-2" style="direction:rtl">
            <v-row>
                <v-col cols="12" md="6" sm="12">
                    <label>{{lang.received_date}}</label>
                    <b-form-input
                        class="inborder"
                        type="date"
                        v-model="received_date"
                        />
                </v-col>
                <v-col cols="12" md="6" sm="12">
                    <label>{{lang.delivery_date}}</label>
                    <b-form-input
                        class="inborder"
                        type="date"
                        v-model="delivery_date"
                        />
                </v-col>
                <v-col cols="12" md="12" sm="12" v-for="(item, index) in cars" :key="index">
                    <v-row>
                        <v-col cols="12" md="3" sm="6">
                            <label>{{lang.plate_number}}</label>
                            <b-form-input
                                class="inborder"
                                v-model="cars[index].plate_number"
                                />
                        </v-col>
                        <v-col cols="12" md="3" sm="6">
                            <label>{{lang.brand_name}}</label>
                            <b-form-input
                                class="inborder"
                                v-model="cars[index].brand"
                                />
                        </v-col>
                        <v-col cols="12" md="3" sm="6">
                            <label>{{lang.car_model}}</label>
                            <b-form-input
                                class="inborder"
                                v-model="cars[index].model"
                                />
                        </v-col>
                        <v-col cols="12" md="3" sm="6">
                            <label>{{lang.car_year}}</label>
                            <b-form-input
                                class="inborder"
                                v-model="cars[index].made_year"
                                />
                        </v-col>
                        <v-col cols="12" md="3" sm="6">
                            <label>{{lang.car_year}}</label>
                            <b-form-input
                                class="inborder"
                                v-model="cars[index].color"
                                />
                        </v-col>
                        <v-col cols="12" md="3" sm="6">
                            <label>{{lang.vin}}</label>
                            <b-form-input
                                class="inborder"
                                v-model="cars[index].vin"
                                />
                        </v-col>
                    </v-row>

                </v-col>
                <v-col cols="12" md="12" sm="12" class="mt-3">
                    <h4>{{ lang.payments }}</h4>
                    <v-row v-for="(item, index) in payments" :key="index">
                        <v-col cols="12" md="3" sm="6">
                            <label>{{lang.amount}}</label>
                            <b-form-input
                                class="inborder"
                                v-model="payments[index].ftotal"
                                />
                        </v-col>
                        <v-col cols="12" md="3" sm="6">
                            <label>{{lang.date}}</label>
                            <b-form-input
                                class="inborder"
                                type="date"
                                v-model="payments[index].receipt_date"
                                />
                        </v-col>
                        <v-col cols="12" md="3" sm="6">
                            <label>{{lang.paytypes}}</label>
                            <b-form-select
                                class="selborder"
                                :options="payTypesSel"
                                v-model="payments[index].paytype"
                                />
                        </v-col>
                    </v-row>
                </v-col>
            </v-row>
        </div>
        </template>
        <template #footer="" class="shadow">
            <div class="d-flex text-light align-items-center px-3 py-2">
                <b-button type="button" @click="updateCardInfo();" variant="success" class="ma-2" style="width:100px;">{{lang.save}}</b-button>
            </div>
      </template>
        </b-sidebar>
        </v-form>
        
      </div>
</template>


<script>
import axios from 'axios';
import {SnotifyPosition} from 'vue-snotify';
export default{
    data() {
        return {
            id: 0,
            received_date: '',
            delivery_date: '',
            cars: [],
            payments: [],
            paytypes: []
        }
    },
    computed: {
        lang: function(){
            if(this.$cookies.get(this.$store.state.LangCooki) != null){
                if(this.$cookies.get(this.$store.state.LangCooki)  == 'en'){
                    return this.$store.state.lang.en;
                }else if(this.$cookies.get(this.$store.state.LangCooki)  == 'ur'){
                    return this.$store.state.lang.ur;
                }else{
                    return this.$store.state.lang.ar;
                }
            }
            else if(this.$store.state.deflang == 'en'){
                return this.$store.state.lang.en;
            }
            else if(this.$store.state.deflang == 'ur'){
                return this.$store.state.lang.ur;
            }else{
                return this.$store.state.lang.ar;
            }
        },
        payTypesSel: function()
        {
            let t= [];
            for(let i=0;i<this.paytypes.length;i++){
                t.push({text: this.lang.langname == 'ar' ? this.paytypes[i].type_name : this.paytypes[i].type_name_en, value: this.paytypes[i].id})
            }
            return t;
        }
    },
    created(){
        //
    },
    methods: {

        updateCardInfo(){
            const post = new FormData();
            post.append("type", "updateCardDetails");
            post.append('defBranch',localStorage.getItem('defBranch'));
            post.append('financeYear',localStorage.getItem('financeYear'));
            post.append("auth", this.$cookies.get(this.$store.state.COOKIEPhase));
            post.append("lang", this.$cookies.get(this.$store.state.LangCooki));
            post.append("data[id]", this.id);
            post.append("data[received_date]", this.received_date);
            post.append("data[delivery_date]", this.delivery_date);
            post.append("data[cars]", JSON.stringify(this.cars));
            post.append("data[payments]", JSON.stringify(this.payments));
            axios.post(this.$store.state.SAMCOTEC.r_path, post)
            .then((response) => {
                this.$parent.getCard(this.id);
                this.id = 0
                this.received_date = ''
                this.delivery_date = ''
                this.cars = []
                document.getElementById("hideUpdateCard").click();
                this.$parent.$parent.getCard(this.id);

            })
        },
        getCard(){
            const post = new FormData();
            post.append("type", "getCardDetails");
            post.append('defBranch',localStorage.getItem('defBranch'));
            post.append('financeYear',localStorage.getItem('financeYear'));
            post.append("auth", this.$cookies.get(this.$store.state.COOKIEPhase));
            post.append("lang", this.$cookies.get(this.$store.state.LangCooki));
            post.append("data[id]", this.id);
            axios.post(this.$store.state.SAMCOTEC.r_path, post)
            .then((response) => {
                this.received_date = response.data.results.data[0].received_date
                this.delivery_date = response.data.results.data[0].delivery_date
                this.cars = response.data.results.data[0].cars
                this.paytypes = response.data.results.paytypes;
                this.payments = response.data.results.payments;
            })
        },

        getStaticid(id) {
            const post = new FormData();
            post.append("type", "getStaticOptions");
            post.append('defBranch',localStorage.getItem('defBranch'));
            post.append('financeYear',localStorage.getItem('financeYear'));
            post.append("auth", this.$cookies.get(this.$store.state.COOKIEPhase));
            post.append("lang", this.$cookies.get(this.$store.state.LangCooki));
            post.append("data[phrase]", id);
            // post.append("data[phrase]", "convertProducts");
            axios.post(this.$store.state.SAMCOTEC.r_path, post).then((response) => {
                // // console.log("i am here",response.data)
                if(id == 'convertProducts')
                    this.optionsS = response.data.results.data;
                else if(id == 'customerSource')
                    this.sources = response.data.results.data
                else if(id == 'inDustrial')
                    this.inDusts = response.data.results.data
                // // console.log("i am here",this.optionsS);
            });
        },

    },
}
</script>
<style scoped>
.hideIcon {
    display:none;
}
.borderRad_right,  .borderRad_left, .borderRad_none{
    padding:2px 5px !important;
}
</style>